// extracted by mini-css-extract-plugin
export default {"main":"levelselect_main__bIe72","top":"levelselect_top__trcBv","levels":"levelselect_levels__Cmtgr"};